import React from 'react';
import { SectionHeading } from './SectionHeading';
import { VideoCard } from './VideoCard';
import { formatViews, videoThumbnail, videoUrl } from '../utils/video';
import type { Video } from '../types/video';
interface TopVideosProps {
  videos: Video[];
}
export function TopVideos({
  videos
}: TopVideosProps) {
  const [first, ...rest] = videos;
  if (!first) return null;
  return <section id="top" aria-labelledby="top-title" className="scroll-mt-20 py-20 md:py-28" data-id="element-162" data-mp="1w92mwk9342o">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-163" data-mp="5y4g0zfgh7wt">
        <SectionHeading id="top-title" title="Найпопулярніше" subtitle="Випуски, з яких глядачі найчастіше починають знайомство з каналом." data-id="element-164" data-mp="5xkvrc2c27fm" />

        <div className="mt-10 grid gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-165" data-mp="3ta5e06tt96pg">
          <div className="lg:col-span-7" data-id="element-166" data-mp="kv3gm3bw40hs">
            <VideoCard video={first} size="large" data-id="element-167" data-mp="ku237s7ej1ww" />
          </div>

          <ol className="flex flex-col divide-y divide-line lg:col-span-5" data-id="element-168" data-mp="pmlhkrdwy12r">
            {rest.map((video, i) => <li key={video.id} data-id="element-169" data-mp="3ix1he2m1mqml" data-mpi={i}>
                <a href={videoUrl(video)} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-4 py-4 first:pt-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember" data-id="element-170" data-mp="3itvpygpxzcnp">
                  <span className="w-8 shrink-0 font-display text-2xl font-semibold tabular-nums text-muted" data-id="element-171" data-mp="6e1veicfbs04">
                    {i + 2}
                  </span>
                  <div className="relative aspect-video w-32 shrink-0 overflow-hidden rounded-xl sm:w-40" data-id="element-172" data-mp="1i2z88kut5p5">
                    <img src={videoThumbnail(video)} alt="" loading="lazy" className="h-full w-full object-cover" data-id="element-173" data-mp="agezz3ffpjvb" />
                  </div>
                  <div className="min-w-0" data-id="element-174" data-mp="2h7xnyk9lw5xu">
                    <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-paper transition-colors duration-150 group-hover:text-ember sm:text-base" data-id="element-175" data-mp="2h8z24xlx58js">
                      {video.title}
                    </h3>
                    <p className="mt-1 text-sm text-muted" data-id="element-176" data-mp="l3hsd3p52fw6">{formatViews(video.views)}</p>
                  </div>
                </a>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}